<template>
  <div v-if="activeTabView === 'feedback'">
    <FeedbackForm />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FeedbackForm from '@/components/FeedbackForm.vue'

export default {
  components: {
    FeedbackForm,
  },
  computed: {
    ...mapState({
      activeTabView: (state) => state.activeTabView,
      presentation: (state) => state.presentation,
    }),
  },
  watch: {
    'presentation.isEnablePrivateFeedback': {
      handler(value) {
        if (value === false) {
          this.$router.push({
            name: 'presentation',
            params: {
              id: this.$route.params.id,
            },
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>
